// <reference types="cordova-plugin-device"/>
export function isProduction() {
    return process.env.NODE_ENV === 'production';
}
export function isDevelopment() {
    return process.env.NODE_ENV === 'development';
}
export function isMobileApp() {
    return window.cordova != null;
}
export function isAndroidApp() {
    // @ts-ignore
    return isMobileApp() && window.device.platform == 'Android';
}
export function isIOSApp() {
    // @ts-ignore
    return isMobileApp() && window.device.platform == 'iOS';
}
// Converts 1.2.35 into 10235
// Warning: this implies that every number in version is below 100
export function version_code(version) {
    if (isDevelopment()) {
        return 1e5;
    }
    return version
        .split('.')
        .map((x) => ~~x)
        .reverse()
        .map((x, i) => x * Math.pow(100, i))
        .reduce((x, acc) => acc + x, 0);
}
export function getUiVersion() {
    return `Версия: ${UI_VERSION}${isDevelopment() ? '[dev]' : ' '} ${isBeta(UI_VERSION) ? '(Бета)' : ''}`;
}
export function isBeta(version) {
    const split_version = version.split('.').map((x) => ~~x);
    return split_version[2] % 2 == 1;
}
/**
 * function use plugin cordova-device
 *
 * @return {type} description of return value
 */
export function getInfoAboutDevice() {
    if (!isMobileApp()) {
        return null;
    }
    return Object.fromEntries(
    // @ts-ignore
    Object.entries(window.device).filter(([key]) => [
        'cordova',
        // 'isVirtual',
        'platform',
        'sdkVersion',
        'manufacturer',
        'model',
        'version',
    ].includes(key)));
}
export function strInfoAboutDevice() {
    const info = getInfoAboutDevice();
    if (info) {
        return Object.entries(info)
            .map(([key, value]) => `${key} - ${value}`)
            .join('\n');
    }
    return null;
}
export function logInfoAboutDevice() {
    const info = getInfoAboutDevice();
    if (info) {
        console.group('DeviceInfo');
        Object.entries(info).forEach(([key, value]) => console.log(`${key} - ${value}`));
        console.groupEnd();
    }
}
